import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ImageBackground, type ViewStyle } from "react-native"
import { Button, Text, View } from "../../Components/Themed"
import type { CompanyEmbedProps, EmbedProps, MyPlayerProps } from "../../types"
import { PartnerPortalApi } from '../api';
import { useColors } from '../../constants/useColors';

type CreateEmbedProps = {
    me:MyPlayerProps,
    company_id:string,
    float?:boolean,
    header_style?:ViewStyle,
    footer_style?:ViewStyle,
    onClose:() => void,
    onCreateEmbed:(company_embed:CompanyEmbedProps) => void
}

const sections = ['header','info', 'loading','options']
const CreateEmbed = ({ me, company_id, header_style, footer_style, float, onClose, onCreateEmbed }:CreateEmbedProps) => {
    const Colors = useColors();
    const [ size, setSize ] = useState({ height:0, width:0 })
    const [ action_loading, setActionLoading ] = useState(false);
    const [ state, setState ] = useState<{
        loading:boolean,
        embeds:EmbedProps[],
        selected_embed?:EmbedProps
    }>({
        loading:false,
        embeds:[]
    });
    const { loading, embeds, selected_embed } = state;

    useEffect(() => {
        PartnerPortalApi.setEnvironment()
        getData();
    },[company_id]);

    const getData = async() => {
        setState({ ...state, loading:true });
        const s_embeds = await PartnerPortalApi.EmbedApi.getEmbeds();
        setState({ ...state, loading:false, embeds:s_embeds });
    }

    const renderEmbeds = (data:{ item:EmbedProps, index:number }) => {
        const selected = data.item.embed_id == selected_embed?.embed_id ? true : false
        return (
            <Button float style={{ flexDirection:'row', margin:10, padding:0, borderColor:selected ? Colors.text.success:Colors.borders.light }}
            onPress={() => {
                if(selected){ return setState({ ...state, selected_embed: undefined }) }
                return setState({ ...state, selected_embed: data.item })
            }}>
                <Image
                    source={{ uri: data.item.image.url }}
                    style={{ height:75, width:75, borderTopLeftRadius:8, borderBottomLeftRadius:8 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, padding:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }
    
    const renderSections = (data:{ item:string, index:number}) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, ...header_style }}>
                      <View transparent style={{ flex:1 }}>
                        <Text theme='h1'>Create A New Embed</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Select an embed below to create a new one</Text>
                      </View>
                      <Button
                        title='X'
                        float
                        onPress={() => onClose()}
                      />
                    </View>
                )
            case 'info':
                return (
                    <ImageBackground
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1757428505/ChatGPT_Image_Sep_9_2025_09_34_28_AM_vzjage.png' }}
                        style={{ width: size.width, height:225, justifyContent:'flex-end', overflow:'hidden', ...header_style}}>
                        <View type='dark_blur' style={{ padding:20 }}>
                            <Text theme='h1' size={36}>BettorEdge Embeds</Text>
                            <Text theme='description' size={16} style={{ marginTop:3 }}>Engage your audience using BettorEdge games and markets and earn real $$</Text>
                        </View>
                    </ImageBackground>
                )
            case 'loading':
                if(!loading){ return <></> }
                return (
                    <ActivityIndicator style={{ padding:20, alignSelf:'center' }} size='large' />
                )
            case 'options':
                return (
                    <View transparent style={{ padding:10 }}>
                        <FlatList
                            data={embeds}
                            key={'embed_list'}
                            keyExtractor={item => item.embed_id.toString()}
                            renderItem={renderEmbeds}
                        />
                    </View>
                )
            default: return <></>
        }
    }
    return (
        <View style={{ flex:1 }} float={float} onLayout={(ev) => {
            const { width, height } = ev.nativeEvent.layout 
            setSize({ width, height })
        }}>
            <View transparent style={{flex:1}}>
            <FlatList
                data={sections}
                renderItem={renderSections}
                key={'create_embed_sections'}
                keyExtractor={item => item}
            />
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, ...footer_style }}>
              <Button
                title='CREATE NEW EMBED'
                style={{ opacity: selected_embed && !action_loading ? 1 : 0.5, flex:1 }}
                type='success'
                disabled={!selected_embed || action_loading}
                loading={action_loading}
                onPress={async() => {
                    if(!selected_embed){ return }
                    if(action_loading){ return }
                    setActionLoading(true);
                    //Lets create a new Embed!
                    const new_embed = await PartnerPortalApi.CompanyEmbedApi.createCompanyEmbid({
                        company_embed_id: '',
                        company_id,
                        embed_id:selected_embed.embed_id,
                        name: `Pending ${selected_embed.name}`,
                        identifier:'',
                        status: 'pending',
                        properties: {},
                        generated_by: me.player_id,
                        create_datetime: '',last_update_datetime: ''
                    });
                    if(!new_embed){ return alert('Unable to create.  Please try again later') }
                    setActionLoading(false);
                    onCreateEmbed(new_embed)

                }}
              />
            </View>
        </View>
    )
}

export default CreateEmbed